import { useState } from "react";
import { Alert, Box, Card, CardContent, CardHeader, CircularProgress, Container, Grid, IconButton, InputAdornment, TextField, Typography, Pagination } from "@mui/material";
import { TbSearch } from "react-icons/tb";
import { themePalette } from "../../config/theme.config";
import { PublicacionActual } from "../../Interface/IPublicacion";
import IresearhService from "../../services/IresearchService";
import { Link } from "react-router-dom";

export const BusquedaKey: React.FC<{}> = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [error, setError] = useState(false);
    const [publicaciones, setPublicaciones] = useState<PublicacionActual[]>([]);
    const [loading, setLoading] = useState(false);
    const [noresults, setNoresults] = useState(false);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [page, setPage] = useState<number>(1);

    const handleSearch = () => {
        if (searchTerm.length < 4 || searchTerm.length > 100) {
            setError(true);
        } else {
            setError(false);
            setPage(1);
            obtenerPublicaciones(1);
        }
    };

    const obtenerPublicaciones = (pageNumber: number) => {
        setLoading(true);
        IresearhService.GetPublicationsByKeyWord(searchTerm, pageNumber)
            .then((pub) => {
                if (pub.data.totalCount === 0) {
                    setNoresults(true);
                } else {
                    setPublicaciones(pub.data.data);
                    setTotalPages(pub.data.totalPages);
                    setNoresults(false);
                }
            })
            .catch((error) => console.error("Error fetching publications:", error))
            .finally(() => {
                setLoading(false);
            });
    };

    const handlePageChange = (_event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
        obtenerPublicaciones(value);
    };

    return (
        <Container maxWidth="lg" style={{ padding: "20px", textAlign: "center" }}>
            <Box>
                
                <Grid container justifyContent="center">
                    <Grid item xs={12} sm={10} md={8}>
                        <Alert severity="info">Se recomienda utilizar términos en el idioma de la publicación</Alert>
                        <br />
                        <TextField
                            label="Búsqueda por palabra clave"
                            variant="outlined"
                            fullWidth
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleSearch();
                                }
                            }}
                            error={error}
                            helperText={error ? "El texto debe tener de 4 a 100 caracteres" : ""}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            sx={{ color: themePalette.COLOR_SIDEBAR_ICON }}
                                            onClick={handleSearch}
                                        >
                                            <TbSearch />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
            {loading ? (
                <CircularProgress sx={{ marginTop: 3 }} />
            ) : noresults ? (
                <Typography variant="h6" color="textSecondary" sx={{ marginTop: 3 }}>
                    No se encontraron resultados.
                </Typography>
            ) : (
                <>
                    <Box sx={{ marginTop: "20px", paddingTop: "20px", paddingBottom: "20px", boxShadow: publicaciones.length > 0 ? 2 : 0 }}>
                        <Grid container justifyContent="center" alignItems="center">
                            <Grid item xs={12} sm={10} md={10} container spacing={8} justifyContent="center">
                                {publicaciones.map((item) => {
                                    const publicacion_url = `/publicacion/${item.eid}`;
                                    return (
                                        <Grid item xs={12} sm={6} md={4} key={item.doi}>
                                            <Link to={publicacion_url} style={{ textDecoration: 'none' }}>
                                                <Card sx={{ width: '100%', height: 200, display: 'flex', flexDirection: 'column' }}>
                                                    <CardHeader sx={{ backgroundColor: "blue", color: "white", height: 40 }} title="Publicación" />
                                                    <CardContent sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                        <Typography variant="body1" align="center">
                                                            {item.title}
                                                        </Typography>
                                                    </CardContent>
                                                </Card>
                                            </Link>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    </Box>

                    {totalPages > 1 && (
                        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 3 }}>
                            <Pagination
                                count={totalPages}
                                page={page}
                                onChange={handlePageChange}
                                color="primary"
                            />
                        </Box>
                    )}
                </>
            )}
        </Container>
    );
};
